import { render, staticRenderFns } from "./PageTemplate.vue?vue&type=template&id=5041d4de&"
import script from "./PageTemplate.vue?vue&type=script&lang=ts&"
export * from "./PageTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports